import { render, staticRenderFns } from "./CertificationResult.vue?vue&type=template&id=5203dfbf"
import script from "./CertificationResult.vue?vue&type=script&lang=js"
export * from "./CertificationResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports